// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import getTranslatedText from '@/common-utils/functions/getTranslatedText';
// Lang
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.authorizationCode
 * @returns {JSX} RenderAuthorizationCode
 */
function RenderAuthorizationCode({ authorizationCode }) {
    if (!authorizationCode) {
        return null;
    }

    // Constants
    const entity = `authorization_code.${authorizationCode}`;

    return (
        <div className='flex flex-col items-center' title={getTranslatedText(entity, nsTerminal)}>
            <div>{authorizationCode}</div>
            <small className='ellipsis'>
                <Entity entity={entity} namespace={nsTerminal} />
            </small>
        </div>
    );
}

RenderAuthorizationCode.propTypes = {
    authorizationCode: PropTypes.string
};


export default RenderAuthorizationCode;